import React, { useEffect, useState } from "react";
import { SlDrawer, SlOption, SlSelect, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import api from "../../services/api"
import { roles } from "../../utils/constants";
import { Toast } from '../../shared/Toast'
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import "../../Styles.scss"
import { toast } from "react-toastify";

export const campCreativeContext = React.createContext();
function AdsDashboard() {
    const dispatch = useDispatch()

    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [postData, setPostData] = useState([]);
    const [open, setOpen] = useState(false)
    const [languages, setLanguages] = useState([]);
    const [languageSelected, setLanguageSelected] = useState(1);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    const [dashboardStats, setDashboardStats] = useState({});
    const [dashboardAmount, setDashboardAmount] = useState("")

    const [statusSelected, setStatusSelected] = useState("submit");
    const [dateFilter, setDateFilter] = useState("");

    const [defaultDate, setDefaultDate] = useState('');

    useEffect(() => {
        // Get the current date and format it as 'YYYY-MM-DD'
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(today.getDate()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day}`;
        setDefaultDate(formattedDate);
    }, []);

    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    function formatDateToReadable(timestamp) {
        const date = new Date(timestamp * 1000);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        return `${day}-${month}-${year} ${formattedHours}:${formattedMinutes} ${ampm}`;
    }

    const status = [
        { value: "submit", label: "Under Review" },
        { value: "submittolocal", label: "Published" },
        { value: "feedback", label: "Rejected" },
        { value: "finished", label: "Finished" },
        { value: "initiated", label: "Initiated" }
    ]

    const changeLanguageHandler = (event) => {
        setLanguageSelected(event.target.value);
    };

    const changeStatusHandler = (event) => {
        setStatusSelected(event.target.value);

    };

    const getLanguages = async () => {
        if (localStorage.getItem("role") === roles.ops) {
            setLoader(true);
            const response = await api({
                url: `/ads-dashboard/getLanguages`,
                method: "POST",
                responseType: "json",
            });
            setLanguages(response.data.data);
            setLoader(false);
        }
    };

    const approveAdsPost = async (postData) => {
        if (localStorage.getItem("role") === roles.ops) {
            setLoader(true);
            const response = await api({
                url: `/ads-dashboard/approveAdsPostData`,
                method: "POST",
                responseType: "json",
                data: postData
            });
            setOpen(false);
            toast.success("Ads Post approved successfully")
            setLoader(false);
        }
    };

    const getDashboardData = async (languageSelected, statusSelected, dateFilter, page = 0) => {
        if (localStorage.getItem("role") === roles.ops) {
            setLoader(true);
            const response = await api({
                url: '/ads-dashboard/dashboardData',
                method: "POST",
                responseType: "json",
                data: {
                    post_date: dateFilter,
                    lang_id: languageSelected,
                    dist: false,
                    user_type: "local_ads",
                    dist_id: "all",
                    limit: config.PER_PAGE,
                    post_status: statusSelected,
                    page,
                }
            })
            setData(response?.data?.data?.data);
            setTotalPages(Math.ceil(response.data.data.totalCount / config.PER_PAGE));
            setDashboardStats(response?.data?.data?.totalStatusCount);
            setDashboardAmount(response?.data?.data?.totalAmount)
            setLoader(false);
        }

    }

    useEffect(() => {
        if (localStorage.getItem("role") === roles.ops) {
            getDashboardData(languageSelected, statusSelected, dateFilter, currentPage);
        }
    }, [languageSelected, statusSelected, dateFilter, currentPage]);

    useEffect(() => {
        if (localStorage.getItem("role") === roles.ops) {
            getLanguages();
        }
    }, [])
    return (
        <>
            <div class='custom-width'>
                <div class="row" style={{ width: "" }}>
                    <div class="col-sm-2">
                        <div class="card" style={{ borderLeft: '5px solid #087bc7', paddingLeft: '10px' }}>
                            <div class="card-body">
                                <h5 class="card-title">{dashboardStats?.total_count || 0}</h5>
                                <p class="card-text"><h5>TOTAL ADS</h5></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="card" style={{ borderLeft: '5px solid #838b90', paddingLeft: '10px' }}>
                            <div class="card-body">
                                <h5 class="card-title">{dashboardStats?.submit || 0}</h5>
                                <p class="card-text"><h5>PENDING ADS</h5></p>

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="card" style={{ borderLeft: '5px solid #0aa015', paddingLeft: '10px' }}>
                            <div class="card-body">
                                <h5 class="card-title">{dashboardStats?.submittolocal || 0}</h5>
                                <p class="card-text"><h5>PUBLISHED ADS</h5></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="card" style={{ borderLeft: '5px solid #ff0000', paddingLeft: '10px' }}>
                            <div class="card-body">
                                <h5 class="card-title">{dashboardStats?.feedback || 0}</h5>
                                <p class="card-text"><h5>REJECTED ADS</h5></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="card" style={{ borderLeft: '5px solid #50a3c5', paddingLeft: '10px' }}>
                            <div class="card-body">
                                <h5 class="card-title">{dashboardStats?.finished || 0}</h5>
                                <p class="card-text"><h5>FINISHED ADS</h5></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="card" style={{ borderLeft: '5px solid #f07a03', paddingLeft: '10px' }}>
                            <div class="card-body">
                                <h5 class="card-title">{dashboardAmount}</h5>
                                <p class="card-text"><h5>AMOUNT</h5></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body cc-body">
                <div className="">

                    <div className="flex items-center gap-3 flex-wrap mb-3">

                        {/* <aside className="flex items-center gap-3 ml-auto"> */}

                        <div className="w-40">
                            <SlSelect
                                size="medium"
                                placeholder="Select Language"
                                onSlChange={changeLanguageHandler}
                                value={languageSelected}
                            >
                                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                {languages?.map(item => (
                                    <SlOption key={item.lang_id} value={item.lang_id}>
                                        {item.lang_name}
                                    </SlOption>
                                ))}

                            </SlSelect>
                        </div>

                        <div className="w-40">
                            <SlSelect
                                size="medium"
                                placeholder="Select Status"
                                onSlChange={changeStatusHandler}
                                value={statusSelected}
                            >
                                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                {status.map(item => (
                                    <SlOption key={item.value} value={item.value}>
                                        {item.label}
                                    </SlOption>
                                ))}

                            </SlSelect>
                        </div>

                        <div >
                            <SlInput className='w-full' size='medium' type="date" placeholder="Date"
                                onSlInput={(e) => { setDateFilter(e.target.value) }}
                                style={{ width: '230px' }}
                                value={dateFilter || defaultDate}
                            />
                        </div>
                        {/* </aside > */}
                    </div >

                    <div className="mb-4" >
                        <ScrollContainer>

                            < div className=' mb-4' >
                                <table className='table table-bordered'>
                                    <thead className="sticky top-0 ">
                                        <tr>
                                            <th >Name</th>
                                            <th>Mobile No</th>
                                            <th >Ad title</th>
                                            <th>Ad Type</th>
                                            <th>Priority</th>
                                            <th >Price</th>
                                            <th>Submit Time</th>
                                        </tr>
                                    </thead>
                                    {(data?.length && !loader) ? (
                                        <tbody>

                                            {data.map((item) => {
                                                return (
                                                    < tr key={item.index} className="group/details hover:bg-slate-100" >
                                                        <th scope='row' >{item.cust_name}</th>
                                                        <td>{item.mobile_no}</td>
                                                        <td >
                                                            <div style={{ color: "blue", cursor: "pointer" }}
                                                                onClick={async () => { setPostData(item); setOpen(true) }}
                                                            >
                                                                {item.post_title || "-"}</div>
                                                        </td>
                                                        <td>{item.ad_location || "-"}</td>
                                                        <td>{item.ad_premium || "-"}</td>
                                                        <td>{item.adAmount || "-"}</td>
                                                        <td>{formatDateToReadable(item.post_gmt)}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>) : ((!data?.length && !loader)
                                            ? <NoDataFound colspan="8" />
                                            : <TableLoader colspan="8" />
                                    )
                                    }

                                </table>
                            </div >
                            <div className="flex justify-end">
                                {totalPages > 1 && (
                                    <Paginator
                                        pageCount={totalPages}
                                        handlePageClick={handlePageClick}
                                        forcePage={currentPage} />)}
                            </div>
                        </ScrollContainer>
                    </div>
                </div >
            </div >

            <SlDrawer
                label="Ads Post"
                open={open}
                onSlAfterHide={handleRequestClose}
                onSlRequestClose={() => { setOpen(false) }}
                style={{ "--size": "70vw" }}
            >
                <div className="card">
                    <div className="card-header">
                        <div className="flex items-center gap-3" style={{ paddingBottom: "10px" }}>
                            <aside className="flex items-center gap-3">
                                {/* First Column */}
                                <div className="flex-1" style={{ marginRight: "10px" }}>
                                    <div className="card" style={{ marginBottom: "10px" }}>
                                        <div className="card-header">
                                            <img src={postData.link_url} alt="Image" />
                                        </div>
                                    </div>

                                    <div className="card" style={{ marginBottom: "10px" }}>
                                        <div className="card-header">
                                            <p>{postData.post_title}</p>
                                        </div>
                                    </div>

                                    <div className="card" style={{ marginBottom: "10px" }}>
                                        <div className="card-header">
                                            <p>{postData.post_text}</p>
                                        </div>
                                    </div>
                                </div>


                                <div className="flex-1" style={{ marginLeft: "10px" }}>
                                    <p>{`Posted On : ${formatDateToReadable(postData.post_gmt) || "-"}`}</p>
                                    <p>{`Location : ${postData.ad_location ? postData.ad_location : "Mandal"}`}</p>
                                    <p>{`Priority : ${postData.ad_premium ? postData.ad_premium : "Normal"}`}</p>
                                    <p>{`Total Amount : ${postData.adAmount || "-"}`}</p>
                                    <p>{`Ad Dates : ${postData.adsDates ? postData.adsDates.split(',').join(', ') : ''}`}</p>
                                    {postData.adsLocations && postData.adsLocations.length > 0 && (
                                        <p>
                                            Ad Locations : {postData.adsLocations.map((adLocation, index) => {
                                                const locationText = adLocation.mandal_id ?
                                                    `${adLocation.mandal_name}, ${adLocation.dist_name}` :
                                                    `${adLocation.dist_name}`;
                                                return (
                                                    <span key={index}>{locationText}{index < postData.adsLocations.length - 1 ? ', ' : ''}</span>
                                                );
                                            })}
                                        </p>
                                    )}
                                    <p>{`Contact Name : ${postData.cust_name || "-"}`}</p>
                                    <p>{`Contact Number : ${postData.mobile_no || "-"}`}</p>

                                    {(postData.post_status === "submit") ? (<div>

                                        <Button variant="danger" style={{ marginRight: "10px" }}>Reject</Button>

                                        <Button variant="success" style={{ marginLeft: "10px" }}>Approve</Button>

                                    </div>) : null}

                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </SlDrawer>



        </>
    )

}

export default AdsDashboard;